import sectionTabsCss from '../css-snippets/section-tabs';

const html = `
<style>${sectionTabsCss}</style>
<div class="wrapper-container" id="wrapper-container-unique-id" data-id="unique-id" data-attribute="wrapper-container" data-top-padding="true" data-bottom-padding="true"
  data-background="#ffffff" style="background-color: #ffffff;">
  <div class="wrapper-content container" data-attribute="wrapper-content">
    <div class="wrap-header-tab">
      <div class="list-tab-header" data-position="left" data-attribute="list-tab-header" data-color="#8e1d08"
        style="border-color: #8e1d08;">
        <div class="tab-header-item active" data-tab="tab-1" data-attribute="tab-header-item">Product Description</div>
        <div class="tab-header-item" data-tab="tab-2" data-attribute="tab-header-item">Benefits
        </div>
        <div class="tab-header-item" data-tab="tab-3" data-attribute="tab-header-item">Supplement Facts</div>
        <div class="tab-header-item" data-tab="tab-4" data-attribute="tab-header-item">Directions of Use</div>
      </div>
    </div>
    <div class="list-tab-content" data-attribute="list-tab-content">
      <div class="tab-content-item active" data-tab="tab-1" data-attribute="tab-content-item">
        <h1>Product Description</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
      </div>
      <div class="tab-content-item" data-tab="tab-2" data-attribute="tab-content-item">
        <h1>Benefits</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
      </div>
      <div class="tab-content-item" data-tab="tab-3" data-attribute="tab-content-item">
        <h1>Supplement Facts</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
      </div>
      <div class="tab-content-item" data-tab="tab-4" data-attribute="tab-content-item">
        <h1>Directions of Use</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
      </div>
    </div>
  </div>
</div>
`;

export default html;
